import Vue from 'vue'
import {directive as Clickaway} from 'vue-clickaway'
import noCopy from "./noCopy";

Vue.directive('clickaway', Clickaway)
Vue.directive('no-copy', noCopy)